import React, { useState } from 'react';
import { Star, ShoppingBag, Plus, Minus } from 'lucide-react';
import { useCart } from '../context/CartContext';

const FoodCard = ({ food }) => {
    const { addToCart } = useCart();
    const [quantity, setQuantity] = useState(1);

    const handleAddToCart = () => {
        // Add multiple if quantity > 1
        for (let i = 0; i < quantity; i++) {
            addToCart(food);
        }
        // Visual feedback could be added here
        alert(`Added ${quantity} ${food.name}(s) to basket!`);
    };

    return (
        <div className="food-card">
            <div className="card-img-wrapper">
                <img
                    src={food.image}
                    alt={food.name}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=800&q=80";
                    }}
                />
            </div>
            <div className="card-content">
                <div className="card-header">
                    <h3 className="food-name">{food.name}</h3>
                    <span className="food-price">${food.price.toFixed(2)}</span>
                </div>
                <p className="food-desc">{food.description}</p>

                {/* Quantity Selection Form */}
                <div className="card-form" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '1.5rem',
                    background: 'rgba(255,255,255,0.03)',
                    padding: '10px',
                    borderRadius: '12px',
                    border: '1px solid var(--glass-border)'
                }}>
                    <span style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>Quantity</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <button
                            onClick={() => setQuantity(Math.max(1, quantity - 1))}
                            style={{ background: 'var(--glass)', padding: '5px', borderRadius: '5px', color: 'var(--primary)' }}
                        >
                            <Minus size={16} />
                        </button>
                        <span style={{ fontWeight: '700', minWidth: '20px', textAlign: 'center' }}>{quantity}</span>
                        <button
                            onClick={() => setQuantity(quantity + 1)}
                            style={{ background: 'var(--glass)', padding: '5px', borderRadius: '5px', color: 'var(--primary)' }}
                        >
                            <Plus size={16} />
                        </button>
                    </div>
                </div>

                <div className="card-footer">
                    <div className="rating">
                        <Star size={18} fill="#fbbf24" stroke="none" />
                        <span>{food.rating}</span>
                    </div>
                    <button className="order-btn" onClick={handleAddToCart}>
                        <ShoppingBag size={18} style={{ marginRight: '8px', display: 'inline' }} />
                        Add to Basket
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FoodCard;
